import { render, staticRenderFns } from "./SupplierBase.vue?vue&type=template&id=41680ce9&"
import script from "./SupplierBase.vue?vue&type=script&lang=js&"
export * from "./SupplierBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports